import {
    SET_EMAIL_LOADING,
    CLEAR_EMAIL_MESSAGE,
    CLEAR_EMAIL_ERROR,
    CLEAR_EMAIL_PREVIEW,

    GET_ALL_EMAIL_TEMPLATES_REQUEST,
    GET_ALL_EMAIL_TEMPLATES_SUCCESS,
    GET_ALL_EMAIL_TEMPLATES_FAIL,

    GET_EMAIL_TEMPLATE_REQUEST,
    GET_EMAIL_TEMPLATE_SUCCESS,
    GET_EMAIL_TEMPLATE_FAIL,

    CREATE_EMAIL_TEMPLATE_REQUEST,
    CREATE_EMAIL_TEMPLATE_SUCCESS,
    CREATE_EMAIL_TEMPLATE_FAIL,

    UPDATE_EMAIL_TEMPLATE_REQUEST,
    UPDATE_EMAIL_TEMPLATE_SUCCESS,
    UPDATE_EMAIL_TEMPLATE_FAIL,

    DELETE_EMAIL_TEMPLATE_REQUEST,
    DELETE_EMAIL_TEMPLATE_SUCCESS,
    DELETE_EMAIL_TEMPLATE_FAIL,

    GET_EMAIL_PLACEHOLDERS_REQUEST,
    GET_EMAIL_PLACEHOLDERS_SUCCESS,
    GET_EMAIL_PLACEHOLDERS_FAIL,

    PREVIEW_EMAIL_TEMPLATE_REQUEST,
    PREVIEW_EMAIL_TEMPLATE_SUCCESS,
    PREVIEW_EMAIL_TEMPLATE_FAIL,

    SEND_ACCOUNT_ACTIVATION_REQUEST,
    SEND_ACCOUNT_ACTIVATION_SUCCESS,
    SEND_ACCOUNT_ACTIVATION_FAIL,

    GET_EMAIL_LOGS_REQUEST,
    GET_EMAIL_LOGS_SUCCESS,
    GET_EMAIL_LOGS_FAIL,
    REQUEST_PASSWORD_RESET_REQUEST,
    REQUEST_PASSWORD_RESET_SUCCESS,
    REQUEST_PASSWORD_RESET_FAIL,
    CONFIRM_PASSWORD_RESET_REQUEST,
    CONFIRM_PASSWORD_RESET_SUCCESS,
    CONFIRM_PASSWORD_RESET_FAIL,
    CLEAR_PASSWORD_RESET_STATE,
} from '../actions/emailActions';

const initialState = {
    templates: [],
    currentTemplate: null,
    placeholders: [],
    preview: null,
    logs: [],
    loading: false,
    activationLoading: false,
    message: '',
    activationMessage: '',
    error: null,
    resetLoading: false,
    resetRequestMessage: '',
    resetConfirmMessage: '',
    resetError: null,
};

function emailReducer(state = initialState, action) {
    switch (action.type) {
        case SET_EMAIL_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case CLEAR_EMAIL_MESSAGE:
            return {
                ...state,
                message: '',
                activationMessage: ''
            };

        case CLEAR_EMAIL_ERROR:
            return {
                ...state,
                error: null
            };

        case CLEAR_EMAIL_PREVIEW:
            return {
                ...state,
                preview: null
            };

        // =========================
        // GET ALL TEMPLATES
        // =========================
        case GET_ALL_EMAIL_TEMPLATES_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_ALL_EMAIL_TEMPLATES_SUCCESS:
            return {
                ...state,
                templates: action.payload,
                loading: false,
                message: ''
            };

        case GET_ALL_EMAIL_TEMPLATES_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // =========================
        // GET TEMPLATE BY ID
        // =========================
        case GET_EMAIL_TEMPLATE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_EMAIL_TEMPLATE_SUCCESS:
            return {
                ...state,
                currentTemplate: action.payload,
                loading: false,
                message: ''
            };

        case GET_EMAIL_TEMPLATE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // =========================
        // CREATE TEMPLATE
        // =========================
        case CREATE_EMAIL_TEMPLATE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case CREATE_EMAIL_TEMPLATE_SUCCESS:
            return {
                ...state,
                templates: [...state.templates, action.payload],
                currentTemplate: action.payload,
                loading: false,
                message: 'Template email créé avec succès'
            };

        case CREATE_EMAIL_TEMPLATE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // =========================
        // UPDATE TEMPLATE
        // =========================
        case UPDATE_EMAIL_TEMPLATE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case UPDATE_EMAIL_TEMPLATE_SUCCESS:
            return {
                ...state,
                templates: state.templates.map(template =>
                    template.id === action.payload.id ? action.payload : template
                ),
                currentTemplate:
                    state.currentTemplate?.id === action.payload.id
                        ? action.payload
                        : state.currentTemplate,
                loading: false,
                message: 'Template email mis à jour avec succès'
            };

        case UPDATE_EMAIL_TEMPLATE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // =========================
        // DELETE TEMPLATE
        // =========================
        case DELETE_EMAIL_TEMPLATE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case DELETE_EMAIL_TEMPLATE_SUCCESS:
            return {
                ...state,
                templates: state.templates.filter(template => template.id !== action.payload.id),
                currentTemplate:
                    state.currentTemplate?.id === action.payload.id
                        ? null
                        : state.currentTemplate,
                loading: false,
                message: 'Template email supprimé avec succès'
            };

        case DELETE_EMAIL_TEMPLATE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // =========================
        // PLACEHOLDERS
        // =========================
        case GET_EMAIL_PLACEHOLDERS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_EMAIL_PLACEHOLDERS_SUCCESS:
            return {
                ...state,
                placeholders: action.payload,
                loading: false
            };

        case GET_EMAIL_PLACEHOLDERS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // =========================
        // PREVIEW
        // =========================
        case PREVIEW_EMAIL_TEMPLATE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case PREVIEW_EMAIL_TEMPLATE_SUCCESS:
            return {
                ...state,
                preview: action.payload,
                loading: false
            };

        case PREVIEW_EMAIL_TEMPLATE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // =========================
        // ACCOUNT ACTIVATION
        // =========================
        case SEND_ACCOUNT_ACTIVATION_REQUEST:
            return {
                ...state,
                activationLoading: true,
                error: null,
                activationMessage: ''
            };

        case SEND_ACCOUNT_ACTIVATION_SUCCESS:
            return {
                ...state,
                activationLoading: false,
                activationMessage: action.payload?.message || 'Email d’activation envoyé avec succès'
            };

        case SEND_ACCOUNT_ACTIVATION_FAIL:
            return {
                ...state,
                activationLoading: false,
                error: action.error
            };

        // =========================
        // LOGS
        // =========================
        case GET_EMAIL_LOGS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_EMAIL_LOGS_SUCCESS:
            return {
                ...state,
                logs: action.payload,
                loading: false
            };

        case GET_EMAIL_LOGS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        case REQUEST_PASSWORD_RESET_REQUEST:
            return {
                ...state,
                resetLoading: true,
                resetRequestMessage: '',
                resetConfirmMessage: '',
                resetError: null,
            };

        case REQUEST_PASSWORD_RESET_SUCCESS:
            return {
                ...state,
                resetLoading: false,
                resetRequestMessage: action.payload?.message || 'Si le compte existe, un email a été envoyé.',
            };

        case REQUEST_PASSWORD_RESET_FAIL:
            return {
                ...state,
                resetLoading: false,
                resetError: action.error,
            };

        case CONFIRM_PASSWORD_RESET_REQUEST:
            return {
                ...state,
                resetLoading: true,
                resetConfirmMessage: '',
                resetError: null,
            };

        case CONFIRM_PASSWORD_RESET_SUCCESS:
            return {
                ...state,
                resetLoading: false,
                resetConfirmMessage: action.payload?.message || 'Mot de passe réinitialisé avec succès.',
            };

        case CONFIRM_PASSWORD_RESET_FAIL:
            return {
                ...state,
                resetLoading: false,
                resetError: action.error,
            };

        case CLEAR_PASSWORD_RESET_STATE:
            return {
                ...state,
                resetLoading: false,
                resetRequestMessage: '',
                resetConfirmMessage: '',
                resetError: null,
            };
        default:
            return state;
    }
}

export default emailReducer;